import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getNotificationBellStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      width: 38,
      height: 38,
      minWidth: theme.touchTargets.minWidth,
      minHeight: theme.touchTargets.minHeight,
      justifyContent: 'center',
      alignItems: 'center',
    },
    containerPressed: {
      opacity: 0.7,
    },
    containerHover: {
      opacity: 0.85,
    },
    badge: {
      position: 'absolute',
      top: 2,
      right: 2,
      minWidth: 16,
      height: 16,
      borderRadius: 8,
      backgroundColor: theme.error,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 4,
      zIndex: 1,
    },
    badgeText: {
      color: theme.textOnStatusBadge,
      fontSize: 10,
      fontWeight: '700',
      lineHeight: 14,
    },
  })
